import { render } from "./ImageVerificationInactive.vue?vue&type=template&id=788ab8bf&scoped=true"
import script from "./ImageVerificationInactive.vue?vue&type=script&lang=js"
export * from "./ImageVerificationInactive.vue?vue&type=script&lang=js"

import "./ImageVerificationInactive.vue?vue&type=style&index=0&id=788ab8bf&scoped=true&lang=css"

import exportComponent from "/var/www/spom.vh/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-788ab8bf"]])

export default __exports__